import React from 'react';
import ElevesRoot from 'containers/Eleves/index';
import { PageTrackerWrapper } from 'queries/user/track';
import { ImportEleves } from 'containers/Eleves/Import/Options';
import { FileImport } from 'containers/Eleves/Import/File';
import { ElevesList } from 'containers/Eleves/List';
import {
  ViewsTable,
  RedirectToAnotherView,
  ViewRoot,
} from 'containers/Eleves/List/Table';
import { EleveDetails } from 'containers/Eleves/EleveDetails';
import { EleveForm } from 'containers/Eleves/EleveDetails/Main/General';
import { Presences } from 'containers/Eleves/EleveDetails/Main/Presences';
import { useLocation, useParams } from 'react-router-dom';
import SchoolyearRedirect from 'components/Redirect/SchoolyearRedirect';
import { elevesUrls } from 'containers/Eleves/urls';
import { TitleHelmet } from 'components/TitleHelmet/TitleHelmet';
import { ElevesListPreview } from 'containers/Eleves/Preview';
import { AppelsStatsPreview } from 'containers/RegistreAppel/Preview/Stats';

export function RedirectToGeneral() {
  const location = useLocation();
  const params = useParams<{
    eleveId: string;
  }>();
  if (!params.eleveId) {
    return <SchoolyearRedirect to="eleves" />;
  }

  return (
    <SchoolyearRedirect
      to={`${elevesUrls.eleveDetails(params.eleveId)}/${location.search}`}
    />
  );
}

export const ElevesRoutes = {
  path: 'eleves',
  element: (
    <>
      <TitleHelmet titleKey="sidebar.eleves.title" />
      <ElevesRoot />
    </>
  ),
  children: [
    {
      path: 'import',
      children: [
        {
          index: true,
          element: (
            <PageTrackerWrapper title="Élèves - import">
              <ImportEleves />
            </PageTrackerWrapper>
          ),
        },
        {
          path: 'file',
          element: (
            <PageTrackerWrapper title="Élèves - import - fichier">
              <FileImport />
            </PageTrackerWrapper>
          ),
        },
      ],
    },
    {
      element: <ElevesList />,
      children: [
        {
          path: 'views',
          element: <ViewsTable />,
          children: [
            {
              path: ':viewId',
              element: <ViewRoot />,
            },
            {
              index: true,
              element: <RedirectToAnotherView />,
            },
          ],
        },
        {
          path: 'views/:viewId/preview',
          element: <ElevesListPreview />,
        },
        {
          index: true,
          element: <RedirectToAnotherView />,
        },
      ],
    },
    {
      path: ':eleveId',
      element: <EleveDetails />,
      children: [
        {
          path: 'general',
          element: <EleveForm />,
        },
        {
          path: 'presences',
          element: <Presences />,
        },
        {
          index: true,
          element: <RedirectToGeneral />,
        },
      ],
    },
    {
      index: true,
      element: <RedirectToAnotherView />,
    },
  ],
};

export const ElevesPreviewRoutes = {
  path: 'eleves/:eleveId/presences/preview',
  element: <AppelsStatsPreview />,
};
